import React from "react";
import logo from "../../images/logo_white.png"

const LogoSvg = () => {
  return (
    <img
    className="logo-source dark:invert"
    alt="logo-orginal"
    src={logo}
      width="600"
      height="41"/>
  );
};

export default LogoSvg;
